import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button } from '@mui/material';

import AlertButton from 'components/AlertButton';
import AlertForm from 'components/AlertForm';
import { SUBMIT_FORM } from 'constants/dinerSignupConstants';
import { Close } from '@mui/icons-material';

// TODO rename this component to something more generic since this is actually
//      not specific to promotions, this also handles announcements
const PromotionContent = ({
  context,
  template,
  alert_form_context,
  handleEmailChange,
  handleBirthdayChange,
  onClick,
  onClose,
  errors
}) => (
  <Box
    sx={theme => ({
      borderRadius: '4px',
      background: 'white',
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: { xs: 'column', sm: 'row' },
      maxWidth: '705px',
      minHeight: { md: '225px', sm: '180px' },
      minWidth: { xs: '100vw', md: '450px', sm: '350px' },
      overflow: 'scroll',
      '& *': {
        fontFamily: theme.brandStyles?.body?.fontFamily
      },
      ...theme.brandStyles?.modal
    })}
  >
    <Box
      sx={{
        display: {
          xs: 'flex',
          sm: 'none'
        },
        justifyContent: 'end',
        paddingBottom: '20px'
      }}
    >
      <Close
        data-testid="small-close"
        onClick={onClose}
        aria-hidden
        sx={theme => ({
          ...theme.brandStyles?.icon,
          cursor: 'pointer'
        })}
      />
    </Box>
    {context?.image?.image_url && (
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: { xs: 'hidden' },
          maxWidth: '100%',
          minHeight: { xs: '33vh' }
        }}
      >
        <img
          style={{ maxWidth: '100%' }}
          src={context?.image?.image_url}
          alt="promotion"
        />
      </Box>
    )}
    <Box
      sx={theme => ({
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'between',
        padding: {
          xs: theme.spacing(2),
          sm: `${theme.spacing(1.25)} ${theme.spacing(1.25)} ${theme.spacing(
            4
          )} ${theme.spacing(1.25)}`
        }
      })}
    >
      <Box
        sx={{
          display: {
            xs: 'none',
            sm: 'flex'
          },
          justifyContent: 'end'
        }}
      >
        <Close
          data-testid="medium-close"
          onClick={onClose}
          aria-hidden
          sx={{
            cursor: 'pointer'
          }}
        />
      </Box>
      <Box
        sx={theme => ({
          flex: 1,
          display: 'flex',
          padding: 2,
          justifyContent: 'center',
          flexDirection: 'column',
          height: 'content-fit',
          ...theme.brandStyles?.modal
        })}
      >
        <Typography
          variant="h3"
          align="center"
          sx={theme => ({
            ...theme.brandStyles?.header
          })}
        >
          {context.header}
        </Typography>
        <Typography
          align="center"
          sx={theme => ({
            mb: 2,
            ...theme.brandStyles?.body
          })}
        >
          {context.body}
        </Typography>
        {context?.alertButton?.action === SUBMIT_FORM && (
          <AlertForm
            data-testid="alert-form"
            formContext={alert_form_context}
            handleEmailChange={handleEmailChange}
            handleBirthdayChange={handleBirthdayChange}
            errors={errors}
          />
        )}

        <AlertButton
          handleClick={onClick}
          type="submit"
          buttonProps={context.alertButton}
        />
        {template && template.toLowerCase() === 'promotion' ? (
          <Button
            variant="contained"
            sx={theme => ({
              marginBottom: theme.spacing(2),
              borderRadius: 0,
              ...theme.brandStyles?.button
            })}
            onClick={onClose}
          >
            NO THANKS
          </Button>
        ) : null}
      </Box>
    </Box>
  </Box>
);

PromotionContent.propTypes = {
  context: PropTypes.shape({
    header: PropTypes.string,
    body: PropTypes.string,
    alertButton: PropTypes.shape({
      action: PropTypes.string
    }),
    image: PropTypes.shape({
      id: PropTypes.string,
      image_url: PropTypes.string
    })
  }).isRequired,
  alert_form_context: PropTypes.shape({
    success_body: PropTypes.string,
    success_header: PropTypes.string,
    alert_buttons: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  handleEmailChange: PropTypes.func.isRequired,
  handleBirthdayChange: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string),
  template: PropTypes.string
};

PromotionContent.defaultProps = {
  errors: [],
  template: ''
};

export default PromotionContent;
